import "./Privacy.css";
import "./../../../../index.css";
import { useLang } from "../../../utils/i18n";

const Privacy = () => {
  const lang = useLang();
  if (lang === "en") {
    return (
      <section className="legal-page privacy-page">
        <h1 className="main-heading">Privacy Policy</h1>
        <div className="privacy-content">
          <p>
            <strong>Last updated:</strong> September 2026
            <br />
            <strong>Legal Entity:</strong> Monetique Estratégia e Gestão Financeira Ltda.
            <br />
            <strong>Website:</strong>{" "}
            <a className="email-link" href="https://www.monetiquepro.com" target="_blank" rel="noopener noreferrer">
              www.monetiquepro.com
            </a>
            <br />
            <strong>Contact:</strong>{" "}
            <a className="email-link" href="mailto:info@monetiquepro.com">info@monetiquepro.com</a>
            <br />
            <strong>Country:</strong> Brazil
          </p>

          <p>
            At <strong>Monetique</strong>, we are committed to protecting your privacy and handling your personal data responsibly, in compliance with the{" "}
            <strong>Brazilian General Data Protection Law (LGPD, Law No. 13,709/2018)</strong>. This Privacy Policy explains what information we collect, how it is used and your rights as a data subject.
          </p>

          <h2>1. Data We Collect</h2>
          <p>
            Monetique <strong>does not collect or store personal data directly</strong> through our website.
            <br />
            The only collection of information occurs when a user schedules a meeting via <strong>Calendly</strong>, a tool integrated into our website.
          </p>

          <h3>Calendly (Scheduling Tool)</h3>
          <p>When scheduling a meeting, Calendly may collect:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Selected date and time</li>
            <li>Additional information voluntarily provided in the form</li>
          </ul>
          <p>
            <strong>Monetique does not store this data on its servers.</strong> All processing is done exclusively by Calendly, according to its own Privacy Policy and security standards.
          </p>

          <h2>2. How We Use Your Data</h2>
          <p>Information provided via Calendly is used only to:</p>
          <ul>
            <li>Schedule, confirm and manage your meeting</li>
            <li>Send information related to the requested service</li>
          </ul>
          <p>Monetique does not use this data for marketing, advertising, profiling, or any other commercial purpose.</p>

          <h2>3. Third Party Services</h2>
          <p>Currently, Monetique uses only Calendly as a third party service.</p>
          <ul>
            <li>We do not use analytics tools (such as Google Analytics).</li>
            <li>We do not use tracking or advertising cookies.</li>
            <li>We do not use plugins or additional data collection mechanisms.</li>
          </ul>
          <p>Our website was built entirely with React, without integrations that perform automated data collection.</p>

          <h2>4. Data Storage and Retention</h2>
          <p>
            Monetique does not store users' personal data in its systems.
            <br />
            All information entered into Calendly is processed and stored exclusively by them, following their internal retention policies.
            <br />
            Monetique does not download, export, or maintain this data locally, except in cases of an explicit user request for service related purposes.
          </p>

          <h2>5. Data Sharing</h2>
          <p>
            Monetique does not sell or disclose personal data to third parties for their own purposes.
          </p>
          <p>
            The website is technically maintained by{" "}
            <strong>
              <a href="https://thewhizkind.com" target="_blank" rel="noopener noreferrer">
                Prayrit Singh (thewhizkind)
              </a>
            </strong>
            , who may have limited technical access where necessary for the operation, maintenance and security of the website. This access is restricted to technical purposes and does not involve the independent use of personal data. The{" "}
            <strong>
              <a href="https://www.thewhizkind.com/privacy-policy" target="_blank" rel="noopener noreferrer">
                thewhizkind Privacy Policy
              </a>
            </strong>{" "}
            can be found here.
          </p>

          <h2>6. Data Subject Rights (LGPD)</h2>
          <p>According to the LGPD, you have the right to:</p>
          <ul>
            <li>Confirm whether we process your data</li>
            <li>Request access to your personal data</li>
            <li>Request correction, deletion, or update of information</li>
            <li>Request anonymisation or blocking</li>
            <li>Limit the use of your data</li>
            <li>Withdraw consent at any time</li>
            <li>Request data portability</li>
            <li>File a complaint with the ANPD (Brazilian Data Protection Authority)</li>
          </ul>
          <p>
            To exercise your rights, please contact: <a href="mailto:info@monetiquepro.com">info@monetiquepro.com</a>.
          </p>

          <h2>7. Cookies</h2>
          <p>
            The Monetique website does not use tracking, advertising, or personalisation cookies.
            <br />
            Calendly may use strictly necessary cookies for the scheduling tool to function. These cookies are controlled by them.
          </p>

          <h2>8. Security Measures</h2>
          <p>Even without storing personal data, we follow good security practices, including:</p>
          <ul>
            <li>Encrypted connections (HTTPS)</li>
            <li>Limited technical access</li>
            <li>Best practices for digital infrastructure protection</li>
          </ul>

          <h2>9. Updates to This Policy</h2>
          <p>
            We may update this Privacy Policy if new services or features are implemented. Future changes will be published on this page with the revised date.
          </p>

          <p>
            If you have questions about this Privacy Policy or how we handle your data, please contact:
            <br />
            <a className="email-link" href="mailto:info@monetiquepro.com">info@monetiquepro.com</a>
          </p>
        </div>
      </section>
    );
  }
  return (
    <section className="legal-page privacy-page">
      <h1 className="main-heading">Política de Privacidade</h1>
      {/* Add HTML Below */}
      <div className="privacy-content">
        <p>
          <strong>Última atualização:</strong> Setembro de 2026
          <br />
          <strong>Razão Social:</strong> Monetique Estratégia e Gestão Financeira Ltda.
          <br />
          <strong>Website:</strong> <a className="email-link" href="https://www.monetiquepro.com" target="_blank" rel="noopener noreferrer">www.monetiquepro.com</a>
          <br />
          <strong>Contato:</strong> <a className="email-link" href="mailto:info@monetiquepro.com">info@monetiquepro.com</a>
          <br />
          <strong>País:</strong> Brasil
        </p>

        <p>
          Na <strong>Monetique</strong>, temos o compromisso de proteger a sua privacidade e tratar seus dados pessoais com responsabilidade, em conformidade com a{" "}
          <strong>Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018)</strong>. Esta Política de Privacidade explica quais informações coletamos, como elas são utilizadas e quais são os seus direitos como titular de dados.
        </p>

        <h2>1. Quais Dados Coletamos</h2>
        <p>
          A Monetique <strong>não coleta nem armazena dados pessoais diretamente</strong> por meio do nosso site.
          <br />
          A única coleta de informações ocorre quando o usuário agenda uma reunião através do <strong>Calendly</strong>, ferramenta integrada ao nosso website.
        </p>

        <h3>Calendly (Ferramenta de Agendamento)</h3>
        <p>Ao marcar uma reunião, o Calendly pode coletar:</p>
        <ul>
          <li>Nome</li>
          <li>Endereço de e-mail</li>
          <li>Data e horário escolhidos</li>
          <li>Informações adicionais voluntariamente fornecidas no formulário</li>
        </ul>
        <p>
          <strong>A Monetique não armazena esses dados em seus servidores.</strong> Todo o processamento é feito exclusivamente pelo Calendly, de acordo com sua própria Política de Privacidade e padrões de segurança.
        </p>

        <h2>2. Como Utilizamos Seus Dados</h2>
        <p>As informações fornecidas via Calendly são utilizadas apenas para:</p>
        <ul>
          <li>Agendar, confirmar e gerenciar sua reunião</li>
          <li>Enviar informações relacionadas ao atendimento solicitado</li>
        </ul>
        <p>A Monetique não utiliza esses dados para marketing, publicidade, criação de perfis ou qualquer finalidade comercial adicional.</p>

        <h2>3. Serviços de Terceiros</h2>
        <p>Atualmente, a Monetique utiliza somente o Calendly como serviço terceirizado.</p>
        <ul>
          <li>Não utilizamos ferramentas de análise (como Google Analytics).</li>
          <li>Não utilizamos cookies de rastreamento ou publicidade.</li>
          <li>Não empregamos plugins ou mecanismos adicionais de coleta de dados.</li>
        </ul>
        <p>Nosso website foi desenvolvido inteiramente com a biblioteca React, sem integrações que realizem coleta automatizada de dados.</p>

        <h2>4. Armazenamento e Retenção de Dados</h2>
        <p>
          A Monetique não armazena dados pessoais de usuários em seus sistemas.
          <br />
          Todas as informações inseridas no Calendly são processadas e armazenadas exclusivamente por eles, seguindo suas políticas internas de retenção de dados.
          <br />
          A Monetique não baixa, exporta ou mantém esses dados localmente, salvo em caso de solicitação explícita do usuário para fins de atendimento.
        </p>

        <h2>5. Compartilhamento de Dados</h2>
        <p>
          A Monetique não vende nem divulga dados pessoais a terceiros para fins próprios.
        </p>
        <p>
          O website é mantido tecnicamente por{" "}
          <strong>
            <a
              href="https://thewhizkind.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              Prayrit Singh (thewhizkind)
            </a>
          </strong>
          , que poderá ter acesso técnico limitado quando necessário para a operação, manutenção e segurança do website. Esse acesso é restrito a fins técnicos e não envolve o uso independente de dados pessoais. A{" "}
          <strong>
            <a href="https://www.thewhizkind.com/privacy-policy" target="_blank" rel="noopener noreferrer">
              Política de Privacidade da thewhizkind
            </a>
          </strong>{" "}
          pode ser consultada aqui.
        </p>

        <h2>6. Direitos do Titular de Dados (LGPD)</h2>
        <p>De acordo com a LGPD, você tem direito a:</p>
        <ul>
          <li>Confirmar se tratamos seus dados</li>
          <li>Solicitar acesso aos seus dados pessoais</li>
          <li>Solicitar correção, exclusão ou atualização de informações</li>
          <li>Solicitar anonimização ou bloqueio</li>
          <li>Limitar o uso de seus dados</li>
          <li>Retirar o consentimento a qualquer momento</li>
          <li>Solicitar portabilidade</li>
          <li>Registrar reclamação junto à ANPD (Autoridade Nacional de Proteção de Dados)</li>
        </ul>
        <p>
          Para exercer seus direitos, basta entrar em contato: <a href="mailto:info@monetiquepro.com">info@monetiquepro.com</a>.
        </p>

        <h2>7. Cookies</h2>
        <p>
          O site da Monetique não utiliza cookies de rastreamento, publicidade ou personalização.
          <br />
          O Calendly pode usar cookies estritamente necessários para o funcionamento da ferramenta de agendamento. Esses cookies são controlados por eles.
        </p>

        <h2>8. Medidas de Segurança</h2>
        <p>Mesmo sem armazenar dados pessoais, adotamos boas práticas de segurança, incluindo:</p>
        <ul>
          <li>Conexões criptografadas (HTTPS)</li>
          <li>Acesso técnico limitado</li>
          <li>Boas práticas de proteção de infraestrutura digital</li>
        </ul>

        <h2>9. Atualizações desta Política</h2>
        <p>
          Podemos atualizar esta Política de Privacidade caso novos serviços ou funcionalidades sejam implementados. Alterações futuras serão divulgadas nesta página com a data revisada.
        </p>

        <p>
          Se tiver dúvidas sobre esta Política de Privacidade ou sobre como tratamos seus dados, entre em contato:
          <br />
          <a className="email-link" href="mailto:info@monetiquepro.com">info@monetiquepro.com</a>
        </p>
      </div>
    </section>
  );
};

export default Privacy;
